import React, { useEffect, useState } from 'react';
import DocumentLink from '../../components/documents/DocumentLink';
import PageTab from '../../components/dashboard/PageTab';
import PageTabTitle from '../../components/dashboard/PageTabTitle';
import PageTabBody from '../../components/dashboard/PageTabBody';

const CommonLegalDocuments = () => {
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    try {
      const context = require.context('/public/legalDocuments/common', false, /\.pdf$/);
      const docs = context.keys();

      setDocuments(docs);
    } catch (error) {
      console.error("Directory '/public/legalDocuments/common' does not exist.");
    }
  }, []);

  return (
    <PageTab>
      <PageTabTitle>Bendri teisės aktai</PageTabTitle>
      <PageTabBody>
        {documents.map((filename, index) => (
          <DocumentLink key={index} directory={'/legalDocuments/common'} filename={filename} />
        ))}
      </PageTabBody>
    </PageTab>
  );
};

export default CommonLegalDocuments;
